import './split_media_text.scss';
